<template>
<div v-if="!tech">
    <div class="container">
        <div v-if="loading" class="loading"></div>
        <div class="manager-page">
            <img v-if="manager.image" :src="axios.defaults.baseImageURL +  manager.image">
            <div class="t">{{ manager.name }}</div>
            <div class="t">{{ manager.email }}</div>
            <div class="t">{{ manager.phone }}</div>
        </div>
    </div>
</div>
<div v-else>
    <div class="text-center mt-5">Техничесике неполадки. Свяжитесь с менеджером: +7 747 717 60 60</div>
</div>

</template>

<script>
    export default {
        name: "ManagerPage",
        data(){
            return{
                manager: [],
                loading: false,
                tech: false
            }
        },

        mounted() {
            this.axios
                .post(this.axios.defaults.baseURL + 'check-issue', {
                    'selected': 'История'
                })
                .then(response => {
                    if(response.data.message == 'issued') {
                        this.tech = true
                    }
                })

            this.loading = true
            this.axios
            .get(this.axios.defaults.baseURL + 'manager')
            .then(response => {
                this.manager = response.data.manager
            }).catch(error => {

            }).finally(() => {
                this.loading = false
            });
        }
    }
</script>

<style scoped>

    img{
        width: 325px;
        object-fit: contain;
        object-position: center;
    }
    .manager-page{
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .t{
        font-size: 20px;
        font-weight: 600;
        padding-top: 15px;
    }

</style>



// WEBPACK FOOTER //
// src/views/app/pages/ManagerPage.vue